import {Component} from '@angular/core';
import {GLOBAL} from "../../globals";
import {UserService} from '../../services/user.service';
import {Router} from '@angular/router';
import {ProgressService} from '../../services/progress.service';
import {User} from '../../model/Entities/User';

@Component({
    selector: 'user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent {
    private BASE_PATH = GLOBAL.BASE_PATH;
    user: User;

    constructor(private userService: UserService,
                private progressService: ProgressService,
                private router: Router) {
        this.user = this.userService.getLoggedUser();
    }

    public logout() {
        this.progressService.startLoading('logout');
        this.userService.logout().subscribe(() => {
            this.progressService.stopLoading('logout');
            this.router.navigate(['login']);
        });
    }
}



// WEBPACK FOOTER //
// /app/src/UsersModule/UserProfileComponent/user-profile.component.ts